import { Injectable, signal, computed } from '@angular/core';
import { IonContent } from '@ionic/angular/standalone';
import { PAGE } from 'src/app/routes';

@Injectable({ providedIn: 'root' })
export class ScrollStateService {
  private activeTab = signal<string>(PAGE.LOADING);
  private appReadyState = signal(false);

  isGameRoute = computed(() => this.activeTab() === PAGE.GAME);
  isLeaderboardRoute = computed(() => this.activeTab() === PAGE.CHOOSE_LEADERBOARDS);
  isAppReady = this.appReadyState.asReadonly();

  setAppReady(): void {
    this.appReadyState.set(true);
  }

  public handleNavigationEnd(url: string, content?: IonContent): void {
    this.activeTab.set(this.urlToTabId(url));
    content?.scrollToTop(0);
  }

  private urlToTabId(url: string): string {
    const segment = url.split('/').filter(Boolean)[0] ?? '';
    const values = Object.values(PAGE);
    return values.includes(segment) ? segment : PAGE.LOADING;
  }
}
